export const TITLE_MODAL_GRID = "¿Deseas finalizar tu test?"
export const ALERT_MODAL_GRID_DESCRIPTION = "Enviaremos tus respuestas";
export const TIMER_INITIAL_VALUE = 10;